import { Component, Fragment } from 'react';
import {
    Box,
    Collapse,
    Grid,
} from '@mui/material';

const Constants = require("../constants/Constants");
let CCLIST = Constants.CCLIST
let IMAGE_URL = Constants.IMAGE_URL


class CCSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { value: "" }
        this.id = props.id
    }

    render() {

        const headerWidth = this.props.headerWidth ?? '50%'

        return (
            <Fragment>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 2 }}
                >
                    <img
                        src={`${this.props.ccData.url}`}
                        onClick={this.props.toggleCC}
                        alt={this.props.ccData.name}
                        style={{ width: headerWidth, borderRadius: 12 }}
                        value={this.props.ccData.id}
                    />
                </Box>
                <Box sx={{ mt: 1 }}>
                    <Collapse in={this.props.showCC}>
                        <Grid container>
                            {CCLIST.ccs?.map((cc) => (
                                <Grid item sx={{ width: { xs: 1 / 2, md: 1 / 4 } }} key={`cc-${cc.id}`}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{ p: 0.5 }}
                                    >
                                        <img
                                            src={`${IMAGE_URL}${cc.url}`}
                                            alt={cc.name}
                                            loading="lazy"
                                            value={cc.id}
                                            name={cc.name}
                                            style={{ width: "80%", maxWidth: "200px", borderRadius: 12 }}
                                            onClick={(event) => this.props.handleCC(event)}
                                        />
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Collapse>
                </Box>
            </Fragment>

        )

    }
}

export default CCSelect
